export default {
	lang:'en',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav0": 'Account security',
		"nav1": 'My cloud drive',
		"nav2": 'Login out',
		"nav3": 'Login/Regis',
		"nav4": 'Can record phone calls and audio content, and convert them into text. VTransBUDS series headphones need to be connected for use.',
		"nav5": 'download',
		"nav6": 'Important communication, efficient traceability',
		"speaker_not_null": 'Cannot edit speaker as blank!',
		"speaker": 'speaker',
		"copy_success": 'Replicating Success',
	},
	login:{
		"login1":'Password login',
		"login2":'SMS login',
		"loginTab3":'Email login',
		"login3":'Email',
		"login4":'Login password',
		"login5":'Mobile phone number',
		"login6":'Please select',
		"login7":'Mobile verification code',
		"login8":'Login',
		"login9":'Forgot password',
		"login10":'register',
		"login11":'By logging in, you agree to',
		"login12":'Service',
		"login13":'Privacy',
		"login14":'get code',
		"login15":'CN',
		"login16":'Please enter your account number',
		"login17":'Please enter password',
		"login18":'Login successful!!',
		"login19":'Please enter the verification code!',
		"login20":'Sent successfully!',
		"login21":'and',
		
		"login22":'Recording Cloud',
		"login23":'My Writing',
		"login24":'My conversation',
		"login25":'Account security',
		"login26":'Login out',
		
		"login27":'Email password retrieval',
		"login28":'Mailbox',
		"login29":'Email verification code',
		"login30":'Set login password (6-16 characters)',
		"login31":'Enter login password again',
		"login32":'Submit',
		"login33":'Return to login',
		"login34":'Modified successfully!',
	},
	register:{
		"register1":'Phone',
		"register2":'Please enter your phone number',
		"register3":'Please select',
		"register4":'Mobile code',
		"register5":'Password',
		"register6":'Please enter the verification code',
		"register7":'6-16 characters',
		"register8":'Password confirm',
		"register9":'Mailbox',
		"register10":'Please enter your email address',
		"register11":'Email code',
		"register12":'Please enter the verification code',
		"register13":'I have read and agree',
		"register14":'Please read and check the agree agreement',
		"register15":'Phone number format error/phone number registered',
		"register16":'Mobile verification code error',
		"register17":'Please enter email/email format error',
		"register18":'Email format error',
		"register19":'Email verification code error',
		"register20":'Please set the password to 6-16 characters',
		"register21":'Password format error',
		"register22":'The passwords entered twice are inconsistent',
		"register23":'Please enter password',
		"register24":'registered successfully',
		"register25":'Verification code error',
	},
	recorder:{
		"recorder1":'My cloud drive',
		"recorder2":'Cloud space capacity',
		"recorder3":'Recent Files',
		"recorder331":'Recycle Bin',
		"recorder332":'Deleted All',
		"recorder4":'name',
		"recorder5":'Audio duration',
		"recorder6":'file size',
		"recorder7":'Creation time',
		"recorder8":'operation',
		"recorder9":'Cloud Space Description',
		"recorder10":'audio',
		"recorder11":'OCR files',
		"recorder12":'1.What is cloud space used for?',
		"recorder13":'After recording on the recording pen, you can upload audio and transcribe files to the cloud space. Even if the recording pen is not around, you can still enter the cloud space to view the audio.',
		"recorder14":'2.How to upload cloud space?',
		"recorder15":'Go to "My Files" on the recording pen, select the target file, long press the option that appears, and click "Upload" to upload the file to the cloud space.',
		"recorder16":'3.How to view/manage cloud space files?',
		"recorder17":'Log in to the official website of Beibo and select "My - Recording Pen Cloud Disk" to view the uploaded recording pen files. You can select the target file for downloading, deleting, and other operations. You can clean up the storage in cloud space by deleting cloud space files!',
		
		"recorder18":'Untransferred',
		"recorder19":'View Summary',
		"recorder20":'Speaker',
		"recorder21":'Editors Speaker Name',
		"recorder22":'confirm',
		"recorder23":'download',
		"recorder24":'Download content:',
		"recorder25":'Download settings:',
		"recorder26":'Show Speaker',
		"recorder27":'cancel',
		"recorder28":'Link sharing',
		"recorder29":'Anyone who obtains the link can access it, only reading is supported, and the link is valid for 7 days',
		"recorder30":'Copy Link',
		"recorder31":'Scan for quick access',
		"recorder32":'Intelligent organization',
		"recorder33":'Distinguishing speakers',
		"recorder34":'Intelligent differentiation of transcribed text based on the speakers role',
		"recorder35":'Intelligent spoken language regulation',
		"recorder36":'Automatically filter modal particles, repeating words, and pausing words',
		"recorder37":'Non human voice filtering',
		"recorder38":'Automatically skip audio without human voice or noise during playback',
		"recorder39":'Please select',
		"recorder40":'document',
		"recorder41":'audio frequency',
		"recorder42":'Document+Audio',
		
		"recorder43":'Tips',
		"recorder44":'This operation will delete the file. Do you want to continue?',
		"recorder441":'This operation will delete all file. Do you want to continue?',
		"recorder45":'Confirm',
		"recorder46":'Cancel',
		"recorder47":'Deleted successfully!',
		"recorder48":'Undeleted',
		"recorder49":'No tags yet',
		"recorder50":'Saving',
		"recorder51":'Recycle Bin',
	
	},
	personal:{
		"personal1":'Account settings',
		"personal2":'personal information',
		"personal3":'Avatar',
		"personal4":'Upload files',
		"personal5":'Supports JPG, JPEG, GIF, PNG styles, and images up to 2M in size',
		"personal6":'nickname',
		"personal7":'Please enter your nickname',
		"personal8":'Gender',
		"personal9":'gentleman',
		"personal10":'lady',
		"personal11":'secrecy',
		
		"personal12":'birthday',
		"personal13":'Please select your birthday',
		"personal14":'occupation',
		"personal15":'Please choose a profession',
		"personal16":'Please enter occupation (not mandatory)',
		"personal17":'Country',
		"personal18":'Please select a country',
		"personal19":'preserve',
		"personal20":'personal information',
		"personal21":'Account security',
		"personal22":'Only supports images up to 2M in size',
		"personal23":'Upload successful!',
		"personal24":'Modified successfully!',
		
		"personal25":'Account security',
		"personal26":'password',
		"personal27":'modify',
		"personal28":'E-mail',
		"personal29":'replace',
		"personal30":'Account cancellation',
		"personal32":'Are you sure to cancel your account?',
		"personal33":'After logging out, all content in your account will be cleared. Please operate with caution.',
		"personal34":'cancel',
		"personal35":'confirm',
		"personal36":'Identity verification',
		"personal37":'To confirm that it was your own operation, please complete the identity verification through the email verification code',
		"personal38":'mailbox',
		"personal39":'code',
		"personal40":'Please enter the code',
		"personal41":'Next step',
		"personal42":'Set up a new email',
		"personal43":'mailbox',
		"personal44":'Please enter a new email address',
		"personal45":'code',
		"personal46":'Please enter the code',
		"personal47":'confirm',
		"personal48":'Set a new login password',
		"personal49":'password',
		"personal50":'Please enter a new password',
		"personal51":'Confirm password',
		"personal52":'Please enter the new password again',
		"personal53":'confirm',
		"personal54":'get code',
		
		"personal55":'Email format error',
		"personal56":'Replacement successful!',
		"personal57":'Please set the password to 6-16 characters',
		"personal58":'The passwords entered twice are inconsistent',
		"personal59":'Modified successfully!',
		"personal60":'Logout successful',
		"share_url": "Link Sharing",
		"share_url_7_day": "The sharing link is valid for 7 days. Before it expires, anyone who gets the link can access it.",
		"share_audio": "Audio Recording",
		"share_trans_text": "Transcription",
		"share_summny_text": "Summary",
		"share_map": "Mind Map",
		"share_url_pw": "Access Encryption",
		"share_random_pw": "Password Randomly Generated",
		"share_url_copy": "Copy Link",
		"share_link_pw": "Access Password",
		"share_copy_success": "Copy Successfully!",
		"share_speaker": "Speaker",
		"share_no_update_speaker": "Cannot edit Speaker is empty",
		"share_no_trans":"No transcription",
		"share_no_summny":"No summary",
		"share_no_map":"No map content",
		"share_trans_text_1": "Transcription",
		"share_summny_text_1": "Summary",
		"share_map_1": "Map",
		"share_save": "Save successfully",
		"share_no_map":"Map image not generated",
		"share_update_text": "Edit the transcription text",
		"share_update_text2": "Edit summary text",
		"showLoading": "loading...",
	}
}